export default "__VITE_ASSET__DzIRR4J0__";